import styled from "styled-components";

export const PrincipalDiv = styled.div`
    margin-bottom: 2%;
`;

export const BaseDiv = styled.div`
    background-color: #370459;
    color: white;
    font-weight: bold;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 4%;
    @media only screen and (max-width: 800px) {
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }
`;

export const ContentDiv = styled.div`
    display: flex;
    justify-content: center;
    flex-direction: row;
    width: 100%;
    
    h1 {
        font-size: 20px;
        padding: 2px;
        margin-bottom: 10px;
        color: white;
    }
    p {
        font-size: 16px;
        padding: 1px;
        color: white;
    }
    @media only screen and (max-width: 800px) {
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }
`;

export const LeftSide = styled.div`
    display: flex;
    @media only screen and (max-width: 800px) {
        text-align: center;        
    }
`;

export const Logo = styled.img`
    width: auto;
    height: 90px;
    display: flex;
    align-items: center;
    margin-right: 15%;
    margin-top: 10px;
    @media only screen and (max-width: 800px) {
        width: auto;
        height: 80px;
        margin-right: 0;
        margin-bottom: 5%;
    }
`;


export const AddressDiv = styled.div`
    padding: 10px;
    border-right: 1px solid white;
    width: 370px;
    @media only screen and (max-width: 800px) {
        width: 100%;
        margin-right: 2px;
        border-right: none;
        border-bottom: 1px solid white;
    }
`;

export const ContactDiv = styled.div`
    padding: 10px;
    margin-left: 10px;
    @media only screen and (max-width: 800px) {
        text-align: center;
        width: 100%;      
    }
`;

export const IconsDiv = styled.div`
    padding: 2px;

    .icons {
        width: 1.5em;
        height: 1.5em;
        padding: 1%;
        @media only screen and (max-width: 800px) {
            width: 2.0em;
            height: 2.0em; 
        }
    }
`;


export const ContentDivText = styled.div`
    display: flex;
    justify-content: space-evenly;
`;

export const CopyRight = styled.div`
    text-align: center;
    margin-top: 2%;
    color: var(--purple-dark);
    p {
        color: var(--purple-dark);
    }
    font-weight: bold;
    strong {
        color: var(--orange);
    }
    @media only screen and (max-width: 1450px) {
        margin: 2%;
    }
`;